import React, { useState } from 'react';

import checkLargeTokens from '@amzn/meridian-tokens/base/icon/check-large';
import copyTokens from '@amzn/meridian-tokens/base/icon/copy';
import Icon from '@amzn/meridian/icon';
import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Tooltip from '@amzn/meridian/tooltip';

interface CopyableTextProps {
  value: string;
  ariaLabel: string;
  tooltipMaxWidth?: string;
  truncate?: boolean;
}

const CopyableText = ({ value, ariaLabel, tooltipMaxWidth = '100%', truncate = false }: CopyableTextProps) => {
  const [copied, setCopied] = useState(false);

  const copyText = async () => {
    try {
      if (value) {
        await navigator.clipboard.writeText(`${value}`);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }
    } catch (_e) {
      console.warn('Failed to copy value to clipboard', _e);
    }
  };

  return (
    <Row spacing="100">
      <Link onClick={copyText} aria-label={ariaLabel} type="secondary">
        <Icon tokens={copied ? checkLargeTokens : copyTokens} />
      </Link>
      <Tooltip position="bottom" title={value} maxWidth={tooltipMaxWidth}>
        <Text truncate={truncate}>{value}</Text>
      </Tooltip>
    </Row>
  );
};

export default CopyableText;
